module.exports = __webpack_public_path__ + "static/pid-ug-4-en-createsigncode-f7ba9d1a97fe03a91bae54312b6337d4.png";